function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_80_1181)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.0305 4.8924L5.97363 8.13169",
  stroke: "white",
  strokeWidth: 2.02755,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0305 13.8555L5.97363 10.6162",
  stroke: "white",
  strokeWidth: 2.02755,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3542 6.2838C15.8092 6.2838 16.9888 5.10429 16.9888 3.64929C16.9888 2.19428 15.8092 1.01477 14.3542 1.01477C12.8992 1.01477 11.7197 2.19428 11.7197 3.64929C11.7197 5.10429 12.8992 6.2838 14.3542 6.2838Z",
  stroke: "white",
  strokeWidth: 2.02755,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3542 17.7331C15.8092 17.7331 16.9888 16.5536 16.9888 15.0986C16.9888 13.6436 15.8092 12.4641 14.3542 12.4641C12.8992 12.4641 11.7197 13.6436 11.7197 15.0986C11.7197 16.5536 12.8992 17.7331 14.3542 17.7331Z",
  stroke: "white",
  strokeWidth: 2.02755,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.65063 12.0076C5.10563 12.0076 6.28515 10.8281 6.28515 9.3731C6.28515 7.9181 5.10563 6.73859 3.65063 6.73859C2.19563 6.73859 1.01611 7.9181 1.01611 9.3731C1.01611 10.8281 2.19563 12.0076 3.65063 12.0076Z",
  stroke: "white",
  strokeWidth: 2.02755,
  strokeMiterlimit: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_80_1181"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18.745,
  fill: "white"
})));

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e6b74b90d64dc62a4f122a6c2ab5924ca6fd5da769816875e846bb4655b7a428.svg";
export { ForwardRef as ReactComponent };